<template>
  <div class="switch-tree">
    <div class="list-card md-elevation-3 white bg">
      <div v-if="loading" class="subpanel-header">
        <md-progress-bar md-mode="indeterminate" />
      </div>
      <md-content class="scroll-content md-scrollbar">
        <slot name="first-item-slot" />
        <div
          v-for="item of items"
          :id="'row_' + item.key"
          :key="item.key"
        >
          <div class="tree-row">
            <md-switch
              :value="item.on"
              :disabled="readonly || item.disabled"
              class="md-primary ui-theme-3"
              :class="{
                disabled: readonly || item.disabled,
                selected: item.on,
                error: item.error
              }"
              @mouseover.native="mouseOver(item)"
              @mouseleave.native="mouseLeave(item)"
              @change="value => toggleItem(item, value)"
            />
            <switch-item
              :label="item.label"
              :has-children="!!item.children"
              :is-expanded="expandedMap && expandedMap[item.key]"
              :selected="selected === item.key"
              :disabled="item.disabled"
              :error="item.error"
              :warning="item.warning"
              :tooltip="item.tooltip"
              @click="selectItem(item)"
              @mouseOver="mouseOver(item)"
              @mouseLeave="mouseLeave(item)"
            />
          </div>
          <template v-if="expandedMap && expandedMap[item.key]">
            <div
              v-for="(child, index) of item.children"
              :key="child.key + '_' + index"
              class="tree-row"
            >
              <div v-if="child.action">
                <md-button
                  class="md-primary"
                  :disabled="child.disabled"
                  @click="performAction(child)"
                >
                  {{ child.label }}
                </md-button>
              </div>
              <div
                v-if="!child.action"
                class="child-row"
              >
                <md-switch
                  :value="child.on"
                  :disabled="readonly || item.disabled"
                  class="ui-theme-3"
                  @change="value => toggleItem(child, value)"
                />
                <switch-item
                  :label="child.label"
                  :selected="selected === child.key"
                  :error="child.error"
                  :warning="child.warning"
                  :tooltip="child.tooltip"
                  @click="selectItem(child)"
                />
              </div>
            </div>
          </template>
        </div>
      </md-content>
    </div>
  </div>
</template>

<script>
import SwitchItem from './SwitchItem';

export default {
  name: 'switch-tree',
  components: {
    SwitchItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    expandedMap: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    leftHeading: {
      type: String,
      default: null,
    },
    rightHeading: {
      type: String,
      default: null,
    },
    selected: {
      type: String,
      default: null,
    },
    canClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
      },
    };
  },
  created() {
    this.$eventHub.$on('SWITCHTREE::SCROLL_TO', param => this.scrollTo(param));
  },
  methods: {
    toggleItem(item, value) {
      if (item.children) {
        this.$emit('toggle', item, { value });
      } else {
        this.$emit('toggle', item, { value, isChild: true });
      }
    },
    selectItem(item) {
      if (item.children) {
        this.$forceUpdate();
        this.$emit('select', item, { isChild: false } );
      } else {
        this.$emit('select', item, { isChild: true });
      }
    },
    performAction(actionItem) {
      this.$emit('action', actionItem.action);
    },
    mouseOver(item) {
      this.$emit('mouseOver', item);
    },
    mouseLeave(item) {
      this.$emit('mouseLeave', item);
    },
    close() {
      this.$emit('close');
    },
    scrollTo(id) {
      const element = document.getElementById('row_' + id);
      element.scrollIntoView();
    }
  }
}
</script>

<style scoped>
.switch-tree {
  min-width: 250px;
  height: 100%;
}

.list-card {
  height: 100%;
  padding: 10px 0px 0px 10px;
  border-radius: 5px;
}

.md-content {
  height: calc(100% - 12px);
  overflow-y: auto;
  overflow-x: hidden;
}

.scroll-content {
  display: flex;
  flex-direction: column;
}

.tree-row {
  display: flex;
  justify-content: space-between;
  padding-right: 0.2rem;
}

.child-row {
  padding: 0 1rem;
  display: flex;
}

.switch-item {
  flex: 1;
}

.md-switch {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 3rem;
  padding-left: 4px;
  padding-right: 4px;
  margin: 0;
}
</style>